// extracted by mini-css-extract-plugin
export default {"avatarCustomWrapper":"avatarCircle_avatarCustomWrapper__e8Tb7"};